import BannerHeader from "../../../Components/BannerHeader/BannerHeader";
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav";
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo";
import classes from "./ThesisBinding.module.css";
import AboutThesisBinding from "./AboutThesisBinding/AboutThesisBinding";
import CustomerReview from "../../Body/CustomerReview/CutomerReview";
import Timeline from "../Components/Timeline/Timeline";
import Gallery from "../../Body/Gallery/Gallery";
import FAQ from "../FAQ/FAQ";
import { ContactUs } from "../Components/ContactUs/ContactUs";
import Footer from "../../Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAllFaq } from "../../../Store/actions/FaqAction";
import { urls } from "../../../Routes/Urls";
import useScrollToTop from "../../../Hooks/useScrollToTop";
import SEO from "../../../Components/SEO";

const image = "/Assets/Images/CustomizationOverview.svg";
const steps = [
  {
    number: "01",
    title: "PhD Thesis Submission",
    description:
      "Let's begin with the initial step that involves you submitting your PhD thesis to us via mail i.e. info@rarebiblio.com, or you can submit it by filling out a basic form given below.",
    image: image, // replace with image path if needed
    align: "left",
  },
  {
    number: "02",
    title: "Expert Analysis",
    description:
      "Our team of expert craftsmen will analyze your work completely and according to their genius insights come up with an appropriate binding size.",
    image: image, // replace with image path if needed
    align: "right",
  },
  {
    number: "03",
    title: "Customization & Personalization",
    description:
      "We give you multiple options from selecting the colorful leather to adding your custom logo with precise embossing or designing appealing golden borders. \n \n Our team will be in touch with you throughout to get your approvals and make you feel connected in this amazing craftsmanship of your hard work.",
    image: image, // replace with image path if needed
    align: "left",
  },
  {
    number: "04",
    title: "Honest Pricing",
    description:
      "We work hard to give you an affordable price after a careful study, all the while maintaining the transparency you deserve. \n \n We aim to make sure that you get outstanding value at an affordable price, which reflects our commitment to honesty and fairness.",
    image: image, // replace with image path if needed
    align: "right",
  },
  {
    number: "05",
    title: "Thesis Printing and Binding",
    description:
      "Our skilled artisans start work as soon as you confirm the design and the cost, carefully handcrafting each book with great attention to detail. Your revised thesis, which will highlight your academic accomplishments and make a valuable contribution to your professional library, will arrive soon. \n \n With Rare Biblio, you may embrace the eternal craft of leather binding and let us transform your academic work into an enduring masterpiece.Get started with your PhD thesis binding by submitting the form below.",
    descriptionMobile:"Our skilled artisans handcraft your thesis with great attention to detail, which will highlight your academic accomplishments and make a valuable contribution to your professional library. \n \n With Rare Biblio, you may embrace the eternal craft of leather binding and let us transform your academic work into an enduring masterpiece.",
    image: image, // replace with image path if needed
    align: "left",
  },
];
const bgImage = "Assets/Images/ServicePages/PdfThesisBinding.png"

const ThesisBinding = () => {
  const crumbs = [
    { title: "Home", path: "/" },
    { title: "Thesis binding", path: urls.THESISBINDING },
  ];
  const video = useSelector(
    (state) => state.serviceVideo?.videos?.thesisBindingVideo
  );
  const allFaq = useSelector((state) => state.Faq?.questions);
  const dispatch = useDispatch();
  useEffect(() => {
    getAllFaq("category", "Thesis Binding", "", dispatch);
  }, []);

  const scrollRef = useScrollToTop();

  return (
    <>
     <SEO
        keywords="Phd Thesis Binding"
        title="Top PhD Thesis Book Binding & Dissertation Binding services"
        description="Preserve your hard work in style with Rare Biblio’s premium PhD thesis & dissertation binding services. Get professionally bound, elegant copies—order now!"
        canonicalUrl="https://www.rarebiblio.com/phd-thesis-binding-services"
        structuredData={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Service",
              "@id": "https://www.rarebiblio.com/phd-thesis-binding-services#service",
              "name": "PhD Thesis Binding Services",
              "alternateName": "Thesis Book Binding",
              "image": "https://www.rarebiblio.com/Assets/Icons/logo.jpg",
              "description": "Professional PhD thesis binding services with high-quality materials, customization options, and expert craftsmanship. Preserve your academic work with style.",
              "provider": {
                "@type": "Organization",
                "name": "Rare Biblio",
                "url": "https://www.rarebiblio.com",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
                }
              },
              "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
              },
              "serviceType": "PhD Thesis Book Binding",
              "url": "https://www.rarebiblio.com/phd-thesis-binding-services",
              "sameAs": [
                "https://www.facebook.com/rarebiblio/",
                "https://www.instagram.com/Rarebiblio/",
                "https://www.linkedin.com/company/Rarebiblio",
                "https://in.pinterest.com/rare_biblio/",
                "https://x.com/Rarebiblio"
              ]
            },
            {
              "@type": "FAQPage",
              "@id": "https://www.rarebiblio.com/phd-thesis-binding-services#faqs",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What types of leather covers are available for binding my thesis?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We offer a range of leather options for your thesis binding, including different textures, colors, and finishes. Whether you prefer classic, smooth leather or a more textured, rustic finish, we will help you find the perfect style to suit your preferences. You can also choose from a variety of colors to match your personal taste or institutional guidelines."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I add personalization to my leather-bound thesis?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Your PhD thesis can be personalized with engraved text, such as your name, title, university, and year of completion. We offer elegant fonts and design options for the engraving to ensure your thesis reflects your achievements in a sophisticated manner."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long does the PhD Thesis Binding process take?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our leather book binding process is fully handcrafted, including any customizations requested, which is why it typically takes 2–3 weeks to complete. The timeline may vary depending on the complexity of the binding and the level of customization. We take great care to ensure your thesis is bound to the highest quality standards. If you have a specific deadline, please let us know—we’ll do our best to accommodate your timeline."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Is my thesis protected during the binding process?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we take special care in handling your PhD thesis. During the binding process, we ensure that your thesis remains in perfect condition, using non-invasive techniques that preserve the integrity of your document. Your thesis will be returned to you in excellent condition."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do I need to provide a physical copy of the book or a digital file?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can provide either a physical copy or a digital file—whichever is more convenient for you. However, we recommend submitting a digital file, as it allows us to handle the printing in-house and ensures the best quality for binding and customization."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How is my thesis protected during the binding process?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We understand the value and sensitivity of your thesis. Our team handles all documents with the utmost confidentiality and professionalism. Your work is never shared, reproduced, or used in any way beyond the binding process. We are committed to protecting your intellectual property at every step."
                  }
                }
              ]
            }
          ]
        }}
      />
    
    <div ref={scrollRef}>
      <PrimaryNav />

      <BannerHeader
      bgImage={bgImage}
        crumbs={crumbs}
        title={"PhD Thesis Binding Services"}
        desc={"A thesis is the key that unlocks the door to deeper knowledge"}

      />

      <ServiceVideo
        title={"PhD Thesis Binding "}
        desc={"Rare Biblio acknowledges the years of hard work, sleepless nights, and mental exertion you have devoted to completing your thesis.  \n \n Thus, Rare Biblio won’t let any of your efforts go in vain and is here to offer you to get your Ph.D thesis perfectly leather-bound into royalty and luxury. \n \n Our mission is to preserve your academic journey with the classic style of leather, making sure that your thesis will always be a testament to your commitment and diligence."}
        videoSrc={video}
      />

      <AboutThesisBinding />

      <div className={classes.ThesisBindingSteps}>
        <h2 className={classes.title}>
          How To Get Started With Thesis Binding
        </h2>
        <Timeline steps={steps} />
      </div>

      <div className={classes.contactUs}>
        <ContactUs
          category={"thesisBinding"}
          title={
            "Get started with your PhD thesis binding by submitting the form below."
          }
        />
      </div>


      <Gallery />

      <CustomerReview />

      <FAQ data={allFaq} />

      
      <Footer />
    </div>
    </>
  );
};

export default ThesisBinding;
